// Core packages
import { Injectable } from "@angular/core";

// Third party packages
import { FormlyConfig, FormlyFieldConfig } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";

// Custom packages

// @see https://github.com/asc-lab/ngx-formly-playground/blob/master/app-formly-playground/src/app/shared/services/validations.loader.ts
@Injectable()
export class ValidationLoaderService {
  constructor(
    private translate: TranslateService,
    private formlyConfig: FormlyConfig
  ) {}

  init(): void {
    // Error message without params
    this.formlyConfig.addValidatorMessage("required", (err, field) =>
      this.translate.instant("common.errors.field_is_required")
    );

    // Error message with params
    this.formlyConfig.addValidatorMessage("minlength", (err, field) =>
      this.minlengthValidationMessage(err, field, this.translate)
    );
    this.formlyConfig.addValidatorMessage("maxlength", (err, field) =>
      this.maxlengthValidationMessage(err, field, this.translate)
    );
    this.formlyConfig.addValidatorMessage("min", (err, field) =>
      this.minValidationMessage(err, field, this.translate)
    );
    this.formlyConfig.addValidatorMessage("max", (err, field) =>
      this.maxValidationMessage(err, field, this.translate)
    );

    // @todo add 'email' validator message
    // @todo add 'pattern' validation message

    // Back-end error
    this.formlyConfig.addValidatorMessage("server-error", (err, field) => err);
  }

  private minlengthValidationMessage(
    err,
    field: FormlyFieldConfig,
    translate: TranslateService
  ): string {
    return translate.instant("common.errors.min_length_string", {
      minLength: field.templateOptions.minLength
    });
  }

  private maxlengthValidationMessage(
    err,
    field: FormlyFieldConfig,
    translate: TranslateService
  ): string {
    return translate.instant("common.errors.max_length_string", {
      maxLength: field.templateOptions.maxLength
    });
  }

  private minValidationMessage(
    err,
    field: FormlyFieldConfig,
    translate: TranslateService
  ): string {
    return translate.instant("common.errors.min", {
      min: field.templateOptions.min
    });
  }

  private maxValidationMessage(
    err,
    field: FormlyFieldConfig,
    translate: TranslateService
  ): string {
    return translate.instant("common.errors.max", {
      max: field.templateOptions.max
    });
  }
}
